import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import app from './modules/app'
import session from './modules/session'
import user from './modules/admin/user'
import role from './modules/admin/role'
import tab from './modules/admin/tab'
import company from './modules/admin/company'
import dashboard from './modules/admin/dashboard'
import dealer from './modules/admin/dealer'
import zone from './modules/admin/zone'
import branch from './modules/admin/branch'
import employee from './modules/admin/employee'
import dealercontact from './modules/admin/dealercontact'
import manufacturer from './modules/admin/manufacturer'
import auditlog from './modules/admin/auditlog'
  
import concept from './modules/casis/concept'
import capacity from './modules/casis/capacity'
import figure from './modules/casis/figure'
import fee from './modules/casis/fee'
import projection from './modules/casis/projection'
import holiday from './modules/casis/holiday'
import ratio from './modules/casis/ratio'

import sale from './modules/cems/sale'
import country from './modules/cems/country'

import category from './modules/extranet/category'
import document from './modules/extranet/document'

import claim from './modules/customercare/claim'
import claimattachment from './modules/customercare/claimattachment'
import claimcomplaint from './modules/customercare/claimcomplaint'
import claimdeference from './modules/customercare/claimdeference'
import claimaction from './modules/customercare/claimaction'

import agreement from './modules/tracing/agreement'
import agreementdocument from './modules/tracing/agreementdocument'
import agreementmeasure from './modules/tracing/agreementmeasure'
import workshopinfo from './modules/tracing/workshopinfo'
import segment from './modules/tracing/segment'

 
import department from './modules/preferences/department'
import province from './modules/preferences/province'
import district from './modules/preferences/district'
import generaltype from './modules/preferences/generaltype'
import generaltypevalue from './modules/preferences/generaltypevalue'
import configuration from './modules/preferences/configuration'





const store = new Vuex.Store({
    state: {
        //
        //loading: boolean
    },
    mutations: {
        //
    },
    actions: {

    },
    modules: {
        app,
        session,
        user,
        role,
        tab,
        company,
        dashboard,
        dealer,
        zone,
        branch,
        employee,
        dealercontact,
        manufacturer,
        auditlog,

        concept,
        capacity,
        figure,
        fee,
        projection,
        holiday,
        ratio,

        sale,
        country,

        category,
        document,

        claim,
        claimattachment,
        claimcomplaint,
        claimdeference,
        claimaction,

        agreement,
        agreementdocument,
        agreementmeasure,
        workshopinfo,
        segment,
                        
	    department,
        province,
        district,
        configuration,
        generaltype,
        generaltypevalue,

    }
});

export default store;